import { Combobox } from '@reach/combobox';
import PropTypes from 'prop-types';
import * as React from 'react';
import warning from 'tiny-warning';
import { LegacyComboboxInput } from './legacy.combobox-input.component.js';
import { LegacyComboboxList } from './legacy.combobox-list.component.js';
import { LegacyComboboxPopover } from './legacy.combobox-popover.component.js';
import { filterProps } from '../../../react/components/core/core.utils.js';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

({
  /**
  * Enable the combobox dropdown to overflow outside the modal dialog.
  */
  inModal: PropTypes.bool
});
var LegacyBasicCombobox = renderWithRef('LegacyBasicCombobox', undefined, function (props, ref) {
  var as = props.as,
      component = props.component,
      onSelect = props.onSelect,
      openOnFocus = props.openOnFocus,
      ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      children = props.children,
      className = props.className;
  var processedClassName = Array.from(processStyleProps(props, className ? [className] : undefined)).join(' ');
  var filteredProps = filterProps(props, ['onSelect', 'openOnFocus', 'aria-label', 'aria-labelledby', 'inModal']);
  warning(as === undefined && component === undefined, 'props `as` and `component` not supported as BasicCombobox uses 3rd party lib');
  return /*#__PURE__*/React.createElement(Combobox, {
    onSelect: onSelect,
    openOnFocus: openOnFocus,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: processedClassName
  }, /*#__PURE__*/React.createElement(LegacyComboboxInput, _object_spread_props(_object_spread({
    ref: ref
  }, filteredProps), {
    className: undefined
  })), /*#__PURE__*/React.createElement(LegacyComboboxPopover, {
    inModal: props.inModal
  }, /*#__PURE__*/React.createElement(LegacyComboboxList, null, children)));
});
LegacyBasicCombobox.defaultProps = {
  inModal: false
};
export { LegacyBasicCombobox };